import './style.scss';
import type { ITripLeg } from '../../../../../models/trip-leg.model';
import { TranslationService } from '../../../../../services/translation.service';
import LineBadge from '../../../LineBadge';
import { DateTimeHelper } from '../../../../../helpers/date-time.helper';

function TripLegSelectorResultTripLeg({ tripLeg, onSelect }: { tripLeg: ITripLeg; onSelect?: (() => void) | undefined }) {
  return (
    <div className="trip-leg-selector-search-result-trip-leg pt-3">
      <div className="d-flex justify-content-between flex-nowrap">
        <div className="d-flex align-items-start">
          {tripLeg.serviceJourney.line && <LineBadge line={tripLeg.serviceJourney.line} className="me-1" />}
          <span className="h3 m-0">
            {TranslationService.get('common.towards')} {tripLeg.serviceJourney.direction}
          </span>
        </div>
      </div>
      <div className="my-2 ms-2 w-100">
        <div className="d-flex">
          <span className="align-self-center flex-shrink-0 travel-path travel-path--circle travel-path--start d-inline-block"></span>
          <span>
            <span className="visually-hidden">{TranslationService.get('common.departure')}: </span>
            {DateTimeHelper.toTime(tripLeg.origin.plannedTime)} {tripLeg.origin.stopPoint.name}
          </span>
        </div>
        <div className="travel-path travel-path--center d-inline-block py-2 w-auto">
          <span>
            {TranslationService.get('common.traveltime')} {DateTimeHelper.toDuration(tripLeg.origin.plannedTime, tripLeg.destination.plannedTime)}
          </span>
        </div>
        <div className="d-flex">
          <span className="align-self-center flex-shrink-0 travel-path travel-path--circle travel-path--end d-inline-block"></span>
          <span>
            <span className="visually-hidden">{TranslationService.get('common.arrival')}: </span>
            {DateTimeHelper.toTime(tripLeg.destination.plannedTime)} {tripLeg.destination.stopPoint.name}
          </span>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <button className="btn btn-secondary" onClick={onSelect}>
          {TranslationService.get('common.selectandcontinue')}
        </button>
      </div>
    </div>
  );
}

export default TripLegSelectorResultTripLeg;
